// Centralized content for all screens
// This file contains all text content, images, and URLs used throughout the application

export const content = {
  // ==================== HOME PAGE ====================
  home: {
    seo: {
      title: "Welcome!",
      description: "We are a public bar and event hall! Come down for our weekly events and/or book us for your next wedding / event / fundraiser!",
    },
    hero: {
      title: "KC HALL",
      subtitle: "An event hall and public bar located in",
      location: "O'Fallon, Illinois",
      image: "https://i.imgur.com/KmMxGzq.jpg",
      buttons: {
        contact: "CONTACT US",
        viewEvents: "SEE WEEKLY EVENTS",
      },
    },
    whoWeAre: {
      heading: "Who Are We?",
      description: "We are a for-profit organization, public bar, and event hall! Use us for your next fundraiser / event!",
      images: [
        { src: "https://i.imgur.com/zWHUYA6.jpg", alt: "Main Hall" },
        { src: "https://i.imgur.com/dwvHIUy.jpg", alt: "Lower Hall" },
        { src: "https://i.imgur.com/NnhvS7R.jpg", alt: "Bar" },
      ],
    },
    weeklyEvents: {
      heading: "Weekly Events",
      description: "We hold a variety of events weekly; come on down and join the fun!",
      events: [
        {
          name: "Queen of Hearts",
          description: "Drawing every Tuesday at 7:00 pm.",
        },
        {
          name: "KC raffle",
          description: "held in the second and fourth Wednesday of the month.",
        },
        {
          name: "Fish Fry",
          description: "every Friday from 4:00 to 7:00 PM.",
        },
      ],
      button: "SEE WEEKLY EVENTS",
    },
    services: {
      heading: "What We Offer",
      description: "We Offer a variety of services! Feel free to call us or shoot us an email with your request!",
      button: "VIEW ALL SERVICES",
      items: [
        {
          title: "Wedding Receptions",
          body: "Whether you're celebrating with just family, the entire neighborhood or a large group up to 350 people we can find a place for you.",
          image: "https://i.imgur.com/6Zag0YJ.jpg",
        },
        {
          title: "Corporate Functions",
          body: "Retirement parties, Christmas gatherings, seminars and business meeting, depending on the size of the event can be hosted in the Main or Lower Hall.",
          image: "https://i.imgur.com/KmMxGzq.jpg",
        },
        {
          title: "Happier Holidays",
          body: "Spend time with your guests and enlist our help for your next family holiday.",
          image: "https://i.imgur.com/OTmegVy.png",
        },
        {
          title: "Birthday Parties",
          body: "Have your birthday party at the KC Hall! We offer affordable drink packages and a cozy/fun space to celebrate that special day!",
          image: "https://i.imgur.com/WkY8aFx.jpg",
        },
        {
          title: "Funeral Services and Catering for Sensitive Occasions",
          body: "We can assist you in hosting a memorial service, military event, charity function or fund raiser.",
          image: "https://i.imgur.com/WsJ5ujE.jpg",
        },
        {
          title: "Other",
          body: "Whether your raising money for your school's sports teams, a charitable cause, or for any other worthy reason, the KC Hall is here to help at an affordable rate.",
          image: "https://i.imgur.com/tsnZQ55.jpg",
        },
      ],
    },
  },

  // ==================== ABOUT PAGE ====================
  about: {
    seo: {
      title: "About Us",
      description: "We are open to the public! We are a public bar and event hall available for rent; use us for your next event today!",
    },
    heading: "About Us",
    origins: {
      heading: "Our Origins",
      paragraphs: [
        "The O'Fallon KC Hall is open to the public and is operated by The O'Fallon Columbus Club. The club is proud to present the many venues and services we offer to both our membership and the general public. Please use the navigation above to discover more about the main features of our venue, everyday operations and ongoing events.",
        "The Columbus Club is the \"sister organization\" to the O'Fallon Council of the Knights of Columbus. It is the incorporated entity responsible for the operation and maintenance of the facilities and services. The Columbus Club has a full-time staff of professional employees who are dedicated to making your event a success.",
        "The manager and event coordinator are available from initial booking to the completion of your event. This multi-purpose facility is located directly across from the O'Fallon Community Park on Highway 50 in O'Fallon, Illinois. There is ample parking available on site.",
      ],
    },
    mainHall: {
      heading: "Main Hall",
      description: "The Main Hall is the largest venue available for weddings, auctions, trivia nights and any other large events. Customers, including many charities have found a perfect fit with our low cost structure and have annually hosted their fund raising efforts at our facility.",
      image: "https://i.imgur.com/zWHUYA6.jpg",
    },
    lowerHall: {
      heading: "Lower Hall",
      description: "Smaller events can be held in the Lower Hall area for more intimate gatherings. Depending on availability, both the Main Hall and the Lower Hall can be rented for the same event.",
      image: "https://i.imgur.com/dwvHIUy.jpg",
    },
    amenities: {
      heading: "Amenities",
      image: "https://i.imgur.com/NnhvS7R.jpg",
      paragraphs: [
        "We are equipped with a full-scale kitchen and bar, and depending on the size of the event, we can cater in house or recommend one of our caterers on our preferred list.",
        "Additionally, the halls are equipped with wireless internet and flat screen TV's for projecting presentations.",
      ],
    },
  },

  // ==================== CONTACT PAGE ====================
  contact: {
    seo: {
      title: "Contact Us",
      description: "Get in touch with KC Hall of O'Fallon",
    },
    heading: "Contact Us",
    form: {
      heading: "Send Us a Message",
      fields: {
        name: {
          label: "Name *",
          placeholder: "Your name",
        },
        email: {
          label: "Email *",
          placeholder: "your.email@example.com",
        },
        phone: {
          label: "Phone",
          placeholder: "(123) 456-7890",
        },
        message: {
          label: "Message *",
          placeholder: "Tell us about your event or inquiry...",
        },
      },
      buttons: {
        submit: "Send Message",
        submitting: "Sending...",
      },
      messages: {
        success: "Thank you! We will get back to you soon.",
        error: "Something went wrong. Please try calling us directly.",
      },
    },
    info: {
      heading: "Contact Information",
      manager: {
        label: "Manager",
      },
      phone: {
        label: "Phone",
      },
      email: {
        label: "Email",
      },
      social: {
        label: "Social Media",
        facebook: "Facebook Page",
      },
    },
    location: {
      heading: "Location",
      description: "Located directly across from the O'Fallon Community Park on Highway 50 in O'Fallon, Illinois. Ample parking available on site.",
    },
  },

  // ==================== FACILITIES PAGE ====================
  facilities: {
    seo: {
      title: "Our Facilities",
      description: "We are here to provide for any and all of your needs. We offer Wedding Receptions, Corporate Events, Funeral Services and Catering for Sensitive Occasions, and Holiday Parties.",
    },
    heading: "Available Facilities",
    intro: {
      heading: "What We Have",
      description: "We have multiple facilities to help you with your event. See below what we have to offer; we are happy to accommodate for any occasion.",
    },
    mainHall: {
      heading: "Main Hall",
      image: "https://i.imgur.com/GpO1iRK.jpg",
      paragraphs: [
        "The KC Hall rents its Main Hall for nearly any occasion. The Main Hall is the largest venue and is used by both members and non-members, for wedding receptions, anniversaries, trivia nights, class reunions, birthday celebrations, corporate or retirement parties, and more.",
        "This bright and spacious room comfortably seats 240 guests. From daytime functions to intimate evening affairs, the O'Fallon KC Hall is your final stop.",
        "The outside attached deck adds an outdoor element for any event to enjoy. Our facility accommodates bands, stage acts, and a dance floor to enhance any function.",
        "Also included is a full service bar area to serve you and your guests throughout the event.",
      ],
    },
    lowerHall: {
      heading: "The Lower Hall",
      image: "https://i.imgur.com/hrjlJeF.jpg",
      paragraphs: [
        "The Lower Hall located on the lower level of the facility seats comfortably 100 guests and is perfect for small to medium sized gatherings.",
        "Anniversary parties, bridal showers, business meetings, birthday parties, graduation parties, and company holiday parties are all possible in this comfortable, yet spacious venue.",
        "If you are a charity and wanting to have a fun fundraising event, ask our Manager about \"Celebrity Bartender\" night where you supply the \"bartenders/hosts\" and collect tips for charity.",
        "This lower level room is adjacent to a large bar area and can be used for both catered and non-catered events.",
      ],
    },
    deck: {
      heading: "Deck",
      image: "https://i.imgur.com/q3CwcM7.jpg",
      description: "The outside deck (directly in the back of the Main Hall) is a great place to grab a bucket and enjoy the outdoors!",
    },
    bar: {
      heading: "The Bar",
      image: "https://i.imgur.com/vSAMwKm.png",
      hours: "4:00pm to 10:00pm",
      paragraphs: [
        "The full-service bar is open to the public from 4:00pm to 10:00pm every day except Mondays with extended hours on the weekends, depending on events.",
        "Our full service bar is open to the public. Come down and enjoy a cold beverage. Whether it be beer or bourbon or anything in between we've got you covered.",
      ],
    },
    kitchen: {
      heading: "Kitchen",
      image: "https://i.imgur.com/3xBDSmm.jpg",
      description: "The kitchen menu includes Wednesday wings, Thursday 1/2 pound burgers, and our signature Friday night fish fry's, celebrated as number one in the area by the readers of the Belleville News Democrat. We make fresh made to order pizzas. If you are gluten free, or just watching calories the cauliflower crust is a must!",
    },
    footer: {
      heading: "Wait! There's More",
      description: "See the gallery to see what we've done in the past! We can also cater your event! Contact us or send us an email to see available options.",
    },
  },

  // ==================== ACTIVITIES PAGE ====================
  activities: {
    seo: {
      title: "Weekly Events / Activities",
      description: "Bingo Every Sunday! Come here for the Queen of Hearts drawing on Tuesday nights! We hold a raffle on the second and fourth Wednesday of the Month! Fish Fry every Friday!",
    },
    heading: "Weekly Activities",
    description: "The KC Hall of O'Fallon has great weekly activities like Bingo, Raffles, Fish Fries, and more! Come on down and check us out!",
    events: [
      {
        name: "Queen of Hearts",
        subtitle: "Tuesdays",
        image: "https://i.imgur.com/OLJybrl.png",
        startTime: "7:00pm",
        description: "Queen of Hearts Drawing at 7:00 P.M",
      },
      {
        name: "Xtreme Bar Bingo",
        subtitle: "Tuesdays",
        image: "https://i.imgur.com/2GCVwEc.png",
        startTime: "7:30pm",
        description: "Follows the Queen of Hearts Drawing at 7:30 P.M!",
      },
      {
        name: "KC Raffle",
        subtitle: "Wednesdays",
        image: "https://i.imgur.com/dtHHKsG.png",
        startTime: "6:30pm",
        description: "KC raffle held in the second and fourth Wednesday of the month.",
      },
      {
        name: "Fish Fry",
        subtitle: "Fridays",
        image: "https://i.imgur.com/JVwciMC.jpg",
        startTime: "4:00pm",
        endTime: "7:00pm",
        description: "Always a great night for our Fish Fry – unprecedented in the area, from 4:00 to 7:00 P.M.",
      },
    ],
    concertSeries: {
      heading: "Concert Series",
      description: "Always look for the next concert in the January time frame. In the past we have had tribute artists for Elvis, Buddy Holly, Patsy Cline, the Rat Pack, Elton John, The Eagles, Bob Seeger, Garth Brooks, and many more! This January will be a Journey tribute band to rock the HALL",
      ctaText: "Check out our Facebook page for upcoming concert series!",
    },
  },

  // ==================== SERVICES PAGE ====================
  services: {
    seo: {
      title: "Services",
      description: "We are here to provide for any and all of your needs. We offer Wedding Receptions, Corporate Events, Funeral Services and Catering for Sensitive Occasions, and Holiday Parties.",
    },
    heading: "Our Services",
    description: "Use the KC Hall of O'Fallon for your next event! Whether it's a fundraiser, wedding reception, trivia night, or any other event, we have whatever you need for your next event!",
    items: {
      weddingReceptions: {
        heading: "Wedding Receptions",
        image: "https://i.imgur.com/O9LCFrd.jpg",
        paragraphs: [
          "Whether you're celebrating with just family, the entire neighborhood or a large group up to 350 people, we can find a place for you.",
          "See the gallery to see what we've done in the past!",
        ],
      },
      corporateFunctions: {
        heading: "Corporate Functions",
        image: "https://i.imgur.com/f9azIpp.jpg",
        paragraphs: [
          "Retirement parties, Christmas gatherings, seminars, and business meetings, depending on the size of the event, can be hosted in the Main or Lower Hall. Bring in the heavy hitters for your next company meeting.",
          "We can provide buffet-style meals or plated dinners for your board meeting, annual company picnic, shareholder events or conventions.",
        ],
      },
      happierHolidays: {
        heading: "Happier Holidays",
        image: "https://i.imgur.com/8hsZERo.jpg",
        description: "Enjoy the festive holiday season instead of running yourself ragged in the kitchen. Spend time with your guests and enlist our help for your next family holiday. I'm sure we can find the meal plan and space for you.",
      },
      birthdayParties: {
        heading: "Birthday Parties",
        image: "https://i.imgur.com/WkY8aFx.jpg",
        description: "Have your birthday party at the KC Hall! We offer affordable drink packages and a cozy/fun space to celebrate that special day! We would love to help prepare for your special day.",
      },
      funeralServices: {
        heading: "Funeral Services and Catering for Sensitive Occasions",
        image: "https://i.imgur.com/FgzqFs6.jpg",
        paragraphs: [
          "The KC Hall crew can help you in this time of need. We can assist you in hosting a memorial service, military event, charity function or fund raiser.",
          "We will work together to not only understand the meaning and impact of the event, but also to provide a meal that is suitable for the event.",
        ],
      },
      fundraisers: {
        heading: "Fundraisers",
        image: "https://i.imgur.com/KiprDHH.jpg",
        description: "The KC of O'Fallon is the perfect venue for your next fundraiser! Whether you're raising money for your school's sports teams, a charitable cause, or for any other worthy reason, the KC Hall is here to help at an affordable rate. Have your silent auction and trivia nights here!",
      },
    },
  },

  // ==================== GALLERY PAGE ====================
  gallery: {
    seo: {
      title: "Gallery",
      description: "Check out photos from KC Hall of O'Fallon",
    },
    heading: "Gallery",
    description: "See what we've done in the past! Browse through our collection of event photos.",
    images: [
      { src: "https://i.imgur.com/zWHUYA6.jpg", alt: "Main Hall" },
      { src: "https://i.imgur.com/dwvHIUy.jpg", alt: "Lower Hall" },
      { src: "https://i.imgur.com/NnhvS7R.jpg", alt: "Bar Area" },
      { src: "https://i.imgur.com/GpO1iRK.jpg", alt: "Event Setup" },
      { src: "https://i.imgur.com/hrjlJeF.jpg", alt: "Lower Hall Event" },
      { src: "https://i.imgur.com/q3CwcM7.jpg", alt: "Outdoor Deck" },
      { src: "https://i.imgur.com/vSAMwKm.png", alt: "Bar" },
      { src: "https://i.imgur.com/3xBDSmm.jpg", alt: "Kitchen" },
      { src: "https://i.imgur.com/O9LCFrd.jpg", alt: "Wedding Reception" },
      { src: "https://i.imgur.com/f9azIpp.jpg", alt: "Corporate Event" },
      { src: "https://i.imgur.com/8hsZERo.jpg", alt: "Holiday Party" },
      { src: "https://i.imgur.com/WkY8aFx.jpg", alt: "Birthday Party" },
    ],
  },

  // ==================== NOT FOUND PAGE ====================
  notFound: {
    seo: {
      title: "Page Not Found",
    },
    heading: "404",
    subheading: "Page Not Found",
    description: "Sorry, the page you're looking for doesn't exist or has been moved.",
    button: "Go Back Home",
  },

  // ==================== NAVBAR ====================
  navbar: {
    logo: "KC Hall of O'Fallon",
    mobileMenuTrigger: "Toggle menu",
    mobileMenuTitle: "Menu",
    links: [
      { name: "Home" },
      {
        name: "Events",
        sublinks: [
          { name: "Weekly Events" },
        ],
      },
      { name: "Services" },
      {
        name: "Facilities",
        sublinks: [
          { name: "Available Facilities" },
        ],
      },
      { name: "Gallery" },
      { name: "Contact" },
      {
        name: "Menus",
        sublinks: [
          { name: "Fish Fry Menu" },
          { name: "Fish Fry Lunch Menu" },
          { name: "Lent Fish Fry Menu" },
          { name: "Weekly Menu" },
        ],
      },
    ],
  },

  // ==================== FOOTER ====================
  footer: {
    sections: {
      about: {
        heading: "KC Hall of O'Fallon",
        description: "Your premier event hall and public bar in O'Fallon, Illinois.",
      },
      contact: {
        heading: "Contact",
      },
      social: {
        heading: "Follow Us",
        facebook: "Facebook",
      },
    },
    copyright: "KC Hall of O'Fallon. All rights reserved.",
  },
}
